export class OperaContext {
  public static parentVarientId: string;
  public static objectSpaceName: string;
  public static getOrderOpath: (currentUser: string) => string;
}
